import React from 'react';

export default {
  standard: {
    title: "We're sorry, we cannot progress your client's application further",
    paragraphs: () => [
      "Thank you for applying for finance through Funding Circle. We understand this is a difficult time for many small businesses and we're really sorry we can't help you right now."
    ],
    additionalItem: () => (
      <>
        {' '}
        Please email{' '}
        <a href='mailto:broker@fundingcircle.com'>
          broker@fundingcircle.com
        </a>{' '}
        with any questions.
      </>
    )
  }
};
